export default __webpack_public_path__ + "assets/50896bae80869489908d1883f9c0fe5c.jpeg";